import type { FaireProductEntity } from "../../entity_types/product";

export const p_ddb3vhnacx: FaireProductEntity = {
  token: "p_ddb3vhnacx",
  type: "product",
  name: "Peaches & Cream",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/3edbef2078934995f96a2ebac20692e829f0ddad5f6d6297365bd7810056b8c6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d4bd3e1e96704f21413ee986a3cf691ea90174436a751eaf91652cea3cc6c226.png",
    "https://cdn.faire.com/fastly/ae3b369c509fc31161012bfd60991759d06ccd6cc0545bbd43864c3e5a8e66ef.jpeg",
    "https://cdn.faire.com/fastly/ef780d6cde6934b7d6531973df3ddcc41f90743af4eb9709c59999a6822e793e.jpeg",
    "https://cdn.faire.com/fastly/256751f5e1990db62f1ceb923c159208e018f43a7716fa4511859005e858ad2b.png",
  ],
  priceDollars: 28.99,
  description:
    "An unforgettable fusion of real peach juice, deep, full-bodied vanilla flavors, and white peach gummy flavor makes our Peaches & Cream Soda a perfectly sweet fusion of flavors that refreshes like a summer breeze and satisfies like a southern dessert.\n",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:09.727Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
